const generateIdForMenuItem = (header: string) => {
  return "navigation-bar-item-" + header.toLowerCase();
};

export default generateIdForMenuItem;
